import { useEffect, useState } from 'react';

import styled from '@emotion/styled';
import { LoadingOutlined } from '@ant-design/icons';

interface IToggleButton {
  controller: (...args: any) => void;
  defaultState?: boolean;
  loading?: boolean;
}

export const ToggleButton: React.FC<IToggleButton> = ({
  controller,
  defaultState,
  loading,
}) => {
  const [isOn, setIsOn] = useState(false);

  useEffect(() => {
    if (defaultState) {
      setIsOn(defaultState);
    }
  }, [defaultState]);

  const handleToggle = () => {
    controller();
    setIsOn(!isOn);
  };

  return (
    <StyledToggleButton
      className={loading ? 'load' : isOn ? 'on' : 'off'}
      onClick={loading ? undefined : handleToggle}
    >
      {loading ? (
        <span style={{ fontSize: '10px', marginLeft: '4px' }}>
          <LoadingOutlined />
        </span>
      ) : (
        <MovingCircle className={isOn ? 'on' : 'off'} />
      )}
    </StyledToggleButton>
  );
};

const StyledToggleButton = styled.div`
  width: 2.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  border-radius: 1rem;
  border: 2px solid ${({ theme }) => theme.palette.stateColorGreen};
  cursor: pointer;
  transition: background-color 0.4s ease;

  &.on {
    background-color: ${({ theme }) => theme.palette.stateColorGreen};
  }

  &.off {
    background-color: ${({ theme }) => theme.palette.greyGrey5};
    border: 2px solid ${({ theme }) => theme.palette.greyGrey5};
  }

  &.load {
    background-color: rgba(39, 174, 95, 0.17);
    color: ${({ theme }) => theme.palette.stateColorGreen};
  }
`;

const MovingCircle = styled.div`
  width: 1rem;
  height: 1rem;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 0 1px 0.1px ${({ theme }) => theme.palette.greyGrey3}; 
  transition: transform 0.2s ease;
  transform: translateX(0);

  &.on {
    transform: translateX(1rem);
  }

  &.off {
    background-color: ${({ theme }) => theme.palette.white};
  }
`;
